let iconLibrary: 'fontAwesome4' | 'fontAwesome5' | 'materialSymbolsRounded';

export function SetIconLibrary(library: typeof iconLibrary) {
    iconLibrary = library;
}

export function GetIconLibrary() {
    return iconLibrary;
}